import {Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {MOMDTO, MOMService} from "../api/mom-api.service";
import {ActivatedRoute} from "@angular/router";
import {UserApiService} from "../api/user-api.service";
import {SpinnerService} from "../shared/services/spinner.service";
import {ToastrService} from "ngx-toastr";
import {map, switchMap} from "rxjs/operators";
import {finalize, forkJoin, Subject} from "rxjs";
import {DatePipe} from '@angular/common';
import {DataTableDirective} from 'angular-datatables';
import {escapeHtml, ranaDtOptions, RanaDtOptions} from '../shared/rana-datatable-defaults';

declare const $: any;

@Component({
    selector: 'app-nec-mom',
    templateUrl: './nec-mom.component.html',
    styleUrl: './nec-mom.component.css',
    providers: [DatePipe]
})
export class NecMomComponent implements OnDestroy {
    @ViewChild(DataTableDirective) dtElement!: DataTableDirective;

    userChapter: any;
    username: any;
    userRole: any;
    userGroup: any;
    selectedMom: MOMDTO | null = null;
    moms: MOMDTO[] = [];
    chapterId: string = '';
    userId: string = '';

    dtOptions: RanaDtOptions = ranaDtOptions({columns: []});
    dtTrigger: Subject<any> = new Subject();

    newMom: MOMDTO = {
        title: '',
        chapterId: '',
        userId: '',
        createdDate: '',
        createdBy: '',
        updatedBy: '',
        updatedDate: '',
        description: '',
        visible: true
    };

    constructor(
        private route: ActivatedRoute,
        private momService: MOMService,
        private userApiService: UserApiService,
        private spinner: SpinnerService,
        private toastr: ToastrService,
        private datePipe: DatePipe
    ) {
    }

    ngOnInit(): void {
        this.dtOptions = ranaDtOptions({
            columns: [
                {title: 'Date and Time', data: 'createdDate', render: (d: any) => this.datePipe.transform(d, 'medium') || ''},
                {title: 'Created By', data: 'createdByName', render: (d: any) => escapeHtml(d)},
                {title: 'Title', data: 'title', render: (d: any) => escapeHtml(d)}
            ],
            order: [[0, 'desc']],
            rowCallback: (row: Node, data: any) => {
                const el = row as HTMLElement;
                $(el).off('click').on('click', () => {
                    this.selectedMom = data;
                    $('#modal-view-mom').modal('show');
                });
                el.style.cursor = 'pointer';
                return row;
            }
        });

        this.route.paramMap.subscribe(params => {
            const chapterId ="0";
            const storedUserId = sessionStorage.getItem('userId') || '';
            const storedUserName = sessionStorage.getItem('username') || '';

            this.chapterId = chapterId;
            this.newMom.chapterId = chapterId;
            this.newMom.userId = storedUserId;
            this.moms = [];
            this.viewMOMs(chapterId);

            this.userRole = JSON.parse(sessionStorage.getItem('rolesPermission') || '{}');
            this.userChapter = sessionStorage.getItem('chapter');
            this.username = storedUserName;
            this.userGroup = sessionStorage.getItem('userGroup') || '{}';
        });

    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    private refreshTableData(): void {
        this.dtOptions.data = this.moms.filter(m => m.visible);
        this.rerenderTable();
    }

    private rerenderTable(): void {
        if (this.dtElement?.dtInstance) {
            this.dtElement.dtInstance.then(dt => {
                dt.destroy();
                this.dtTrigger.next(null);
            });
        } else {
            this.dtTrigger.next(null);
        }
    }

    viewMOMs(id: string): void {
        this.spinner.show();
        this.momService.getMOMsByChapterId(id).pipe(
            switchMap((data) => {

                // Sort by createdDate descending
                const sortedMoms = data.sort(
                    (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
                );
             data.forEach(mom => {
                    if (mom.createdDate) {
                        // Simply parse without forcing UTC
                        const parsed = new Date(mom.createdDate);
                        if (!isNaN(parsed.getTime())) {
                            mom.createdDate = parsed;
                        }
                    }
                });


                // For each mom, call userApi to get user details
                const requests = sortedMoms.map(mom =>
                    this.userApiService.getShortData(mom.createdBy).pipe(
                        map(user => ({
                            ...mom,
                            createdByName: user.firstname + ' ' + user.lastname   // attach name
                        }))
                    )
                );

                // Run all requests in parallel
                return forkJoin(requests);
            }),
            finalize(() => this.spinner.hide())
        ).subscribe({
            next: (enrichedMoms) => {
                this.moms = enrichedMoms;
                this.refreshTableData();
            },
            error: (err) => {
                console.error('Error fetching MOMs:', err);
            },
        });
    }







    momInitials(name: string | undefined): string {
        const parts = (name || '').trim().split(/\s+/).filter(p => p);
        const initials = (parts[0]?.charAt(0) || '') + (parts[1]?.charAt(0) || '');
        return initials.toUpperCase() || '?';
    }
}
